import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const MyAccount = ({ handleClose, user, team, plan }) => {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useTranslation();
  const modalRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isMounted &&
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !(
          event.target.classList.contains("ps-menu-button") ||
          event.target.classList.contains("ps-menu-label")
        )
      ) {
        handleClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    setIsMounted(true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef, isMounted, handleClose]);

  return (
    <div ref={modalRef} className="my-account-sidebar">
      {user && user.role === "admin" && (
        <a
          onClick={handleClose}
          href="/users/admin?dashboard"
          className="my-account-sidebar-link"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 4.738V1.787C13 0.8705 12.584 0.5 11.5505 0.5H8.9245C7.891 0.5 7.475 0.8705 7.475 1.787V4.7315C7.475 5.6545 7.891 6.0185 8.9245 6.0185H11.5505C12.584 6.025 13 5.6545 13 4.738Z"
              fill="#486497"
            />
            <path
              d="M13 12.0505V9.4245C13 8.391 12.584 7.975 11.5505 7.975H8.9245C7.891 7.975 7.475 8.391 7.475 9.4245V12.0505C7.475 13.084 7.891 13.5 8.9245 13.5H11.5505C12.584 13.5 13 13.084 13 12.0505Z"
              fill="#486497"
            />
            <path
              d="M5.525 4.738V1.787C5.525 0.8705 5.109 0.5 4.0755 0.5H1.4495C0.416 0.5 0 0.8705 0 1.787V4.7315C0 5.6545 0.416 6.0185 1.4495 6.0185H4.0755C5.109 6.025 5.525 5.6545 5.525 4.738Z"
              fill="#486497"
            />
            <path
              d="M5.525 12.0505V9.4245C5.525 8.391 5.109 7.975 4.0755 7.975H1.4495C0.416 7.975 0 8.391 0 9.4245V12.0505C0 13.084 0.416 13.5 1.4495 13.5H4.0755C5.109 13.5 5.525 13.084 5.525 12.0505Z"
              fill="#486497"
            />
          </svg>
          <span className="text-secondary text-sm font-normal">
            {t("sidebar.account.admin")}
          </span>
        </a>
      )}
      {user && (user.role === "affiliater" || user.role === "admin") && (
        <a
          onClick={handleClose}
          href="/users/affiliater?dashboard"
          className="my-account-sidebar-link"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.2536 1.31152C10.8492 1.25715 10.3071 1.25582 9.5 1.25582C9.15322 1.25582 8.87209 0.974692 8.87209 0.627909C8.87209 0.281125 9.15322 1.89527e-06 9.5 1.89527e-06L9.54354 9.37163e-07C10.2957 -2.36384e-05 10.923 -4.41868e-05 11.4209 0.0669048C11.9465 0.13757 12.4211 0.293016 12.8024 0.674337C13.1837 1.05565 13.3392 1.53019 13.4098 2.05578C13.4768 2.55374 13.4768 3.18099 13.4767 3.93321L13.4767 3.97675C13.4767 4.32353 13.1956 4.60465 12.8488 4.60465C12.5021 4.60465 12.2209 4.32353 12.2209 3.97675C12.2209 3.16967 12.2196 2.62752 12.1652 2.22312C12.1133 1.83678 12.0235 1.67144 11.9144 1.56234C11.8053 1.45323 11.6399 1.36346 11.2536 1.31152ZM7.08559 0.674344C7.3308 0.919559 7.3308 1.31713 7.08559 1.56234C6.97648 1.67144 6.88672 1.83678 6.83477 2.22312C6.7804 2.62752 6.77907 3.16967 6.77907 3.97675C6.77907 4.32353 6.49795 4.60465 6.15116 4.60465C5.80438 4.60465 5.52326 4.32353 5.52326 3.97675L5.52326 3.93321C5.52323 3.18099 5.52321 2.55374 5.59016 2.05578C5.66082 1.53019 5.81627 1.05566 6.1976 0.674337C6.44281 0.429126 6.84038 0.429129 7.08559 0.674344Z"
              fill="#486497"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.77835 3.34884H11.2217C12.7602 3.34883 13.9789 3.34881 14.9327 3.47704C15.9142 3.60901 16.7087 3.88706 17.3352 4.51361C17.5804 4.75883 17.5804 5.1564 17.3352 5.40161C17.09 5.64681 16.6924 5.6468 16.4472 5.40158C16.0929 5.04728 15.6077 4.83491 14.7653 4.72166C13.905 4.60599 12.7708 4.60465 11.1744 4.60465H7.82558C6.22917 4.60465 5.09503 4.60599 4.23466 4.72166C3.39236 4.8349 2.90707 5.04728 2.55276 5.40159M2.55276 5.40159C2.19844 5.75591 1.98607 6.2412 1.87282 7.08351C1.75715 7.94389 1.75581 9.07803 1.75581 10.6744C1.75581 11.658 1.75593 12.471 1.78454 13.16C1.79893 13.5065 1.52971 13.799 1.18323 13.8134C0.836743 13.8278 0.544198 13.5586 0.52981 13.2121C0.5 12.4942 0.5 11.656 0.500001 10.6857L0.5 10.6272C0.499987 9.08861 0.499976 7.86995 0.628206 6.91618C0.760173 5.93462 1.03822 5.14014 1.66476 4.5136C2.2913 3.88707 3.08577 3.60901 4.06733 3.47704C5.02109 3.34881 6.23976 3.34883 7.77835 3.34884M17.8167 7.53543C18.1632 7.52102 18.4557 7.79023 18.4702 8.13671C18.5 8.8546 18.5 9.69281 18.5 10.6631V10.7217C18.5 12.2602 18.5 13.4789 18.3718 14.4327C18.2398 15.4142 17.9618 16.2087 17.3352 16.8352L17.3352 16.8352C16.7087 17.4618 15.9142 17.7398 14.9327 17.8718C13.9789 18 12.7602 18 11.2217 18H7.77834C6.23976 18 5.02109 18 4.06733 17.8718C3.08576 17.7398 2.29129 17.4618 1.66476 16.8352C1.41954 16.59 1.41955 16.1924 1.66476 15.9472C1.90998 15.702 2.30755 15.702 2.55276 15.9472C2.90708 16.3015 3.39236 16.5139 4.23467 16.6272C5.09503 16.7429 6.22917 16.7442 7.82558 16.7442H11.1744C12.7708 16.7442 13.905 16.7429 14.7653 16.6272C15.6076 16.5139 16.0929 16.3015 16.4472 15.9472L16.4472 15.9472C16.8015 15.5929 17.0139 15.1077 17.1272 14.2653C17.2429 13.405 17.2442 12.2708 17.2442 10.6744C17.2442 9.6908 17.2441 8.87789 17.2154 8.18887C17.201 7.84239 17.4702 7.54983 17.8167 7.53543Z"
              fill="#486497"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.5 6.69768C9.84678 6.69768 10.1279 6.9788 10.1279 7.32558V7.33418C11.0395 7.56382 11.8023 8.28253 11.8023 9.27904C11.8023 9.62583 11.5212 9.90695 11.1744 9.90695C10.8276 9.90695 10.5465 9.62583 10.5465 9.27904C10.5465 8.9576 10.1901 8.51166 9.5 8.51166C8.80994 8.51166 8.45349 8.9576 8.45349 9.27904C8.45349 9.60059 8.80996 10.0465 9.5 10.0465C10.6595 10.0465 11.8023 10.85 11.8023 12.0698C11.8023 13.0663 11.0395 13.785 10.1279 14.0147V14.0233C10.1279 14.37 9.84678 14.6512 9.5 14.6512C9.15322 14.6512 8.87209 14.37 8.87209 14.0233V14.0147C7.96054 13.785 7.19767 13.0663 7.19767 12.0698C7.19767 11.723 7.4788 11.4419 7.82558 11.4419C8.17237 11.4419 8.45349 11.723 8.45349 12.0698C8.45349 12.3912 8.80994 12.8372 9.5 12.8372C10.1901 12.8372 10.5465 12.3912 10.5465 12.0698C10.5465 11.7482 10.19 11.3023 9.5 11.3023C8.34047 11.3023 7.19767 10.4988 7.19767 9.27904C7.19767 8.28253 7.96054 7.56382 8.87209 7.33418V7.32558C8.87209 6.9788 9.15322 6.69768 9.5 6.69768Z"
              fill="#486497"
            />
          </svg>
          <span className="text-secondary text-sm font-normal">
            {t("sidebar.account.affiliation")}
          </span>
        </a>
      )}
      <a
        onClick={handleClose}
        href="/users/account?profile"
        className="my-account-sidebar-link"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 0C3.5816 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.4184 16 16 12.4184 16 8C16 3.5816 12.4184 0 8 0ZM8 2.2C9.436 2.2 10.6 3.364 10.6 4.8C10.6 6.236 9.436 7.4 8 7.4C6.564 7.4 5.4 6.236 5.4 4.8C5.4 3.364 6.564 2.2 8 2.2ZM8 14.4C6.0496 14.4 4.3032 13.5272 3.1296 12.1504C2.8248 11.7928 2.8928 11.256 3.268 10.9736C4.4816 10.0608 6.6928 9.6 8 9.6C9.3072 9.6 11.5184 10.0608 12.7328 10.9736C13.108 11.256 13.176 11.7936 12.8712 12.1504C11.6968 13.5272 9.9504 14.4 8 14.4Z"
            fill="#486497"
          />
        </svg>
        <span className="text-secondary text-sm font-normal">
          {t("sidebar.account.edit_account")}
        </span>
      </a>
      <hr className="border-my-account" />
      <a
        onClick={handleClose}
        href="/users/sign_out"
        className="my-account-sidebar-link btn-logout btn"
      >
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.14647 6.65469C3.9512 6.84541 3.9512 7.15459 4.14647 7.34531L5.81313 8.97324C6.0084 9.16396 6.32493 9.16396 6.5202 8.97324C6.71547 8.78252 6.71547 8.47329 6.5202 8.28259L5.70713 7.48837L10.5 7.48837C10.7761 7.48837 11 7.26971 11 7C11 6.73029 10.7761 6.51163 10.5 6.51163L5.70713 6.51163L6.5202 5.7174C6.71547 5.52668 6.71547 5.21751 6.5202 5.02678C6.32493 4.83606 6.0084 4.83606 5.81313 5.02678L4.14647 6.65469Z"
            fill="#486497"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.20327 14L4.4634 14C3.55167 14 2.8168 14 2.2388 13.9241C1.63873 13.8453 1.13353 13.6767 0.7322 13.2848C0.330934 12.8928 0.158333 12.3993 0.0776665 11.8132C2.40527e-07 11.2487 -6.50396e-07 10.5309 -5.72544e-07 9.64038L-1.10884e-07 4.3596C-3.30312e-08 3.46907 9.83393e-07 2.75129 0.0776673 2.18673C0.158334 1.60062 0.330935 1.10717 0.732201 0.715173C1.13353 0.323237 1.63873 0.154652 2.2388 0.075861C2.8168 6.34306e-08 3.55167 1.27675e-07 4.4634 2.07381e-07L5.20327 2.72062e-07C6.115 3.51768e-07 6.84987 4.16013e-07 7.4278 0.0758614C8.02791 0.154652 8.53315 0.323238 8.93443 0.715173C9.20097 0.975573 9.36661 1.28071 9.47145 1.62804C10.1056 1.62882 10.634 1.63566 11.0621 1.69185C11.5714 1.75873 12.0129 1.90348 12.3654 2.24775C12.7179 2.59202 12.866 3.02328 12.9345 3.52077C13 3.99664 13 4.59949 13 5.33712L13 8.66287C13 9.40052 13 10.0033 12.9345 10.4792C12.866 10.9767 12.7179 11.408 12.3654 11.7523C12.0129 12.0965 11.5714 12.2413 11.0621 12.3081C10.634 12.3644 10.1056 12.3712 9.47145 12.372C9.36661 12.7193 9.20097 13.0245 8.93443 13.2848C8.53315 13.6767 8.02791 13.8453 7.4278 13.9241C6.84987 14 6.115 14 5.20327 14ZM9.66667 4.3596C9.66667 3.67594 9.66669 3.09413 9.63153 2.60524C10.1878 2.60732 10.6014 2.61689 10.9288 2.65987C11.3272 2.71222 11.5226 2.80586 11.6583 2.93844C11.794 3.07095 11.8899 3.26174 11.9434 3.65094C11.9989 4.05407 12 4.59089 12 5.37209L12 8.62791C12 9.40911 11.9989 9.94589 11.9434 10.3491C11.8899 10.7382 11.794 10.9291 11.6583 11.0616C11.5226 11.1941 11.3272 11.2878 10.9288 11.3401C10.6014 11.3831 10.1878 11.3926 9.63153 11.3948C9.66669 10.9059 9.66667 10.324 9.66667 9.64039L9.66667 9.60465C9.66667 9.33493 9.44281 9.11628 9.16667 9.11628C8.89052 9.11628 8.66667 9.33493 8.66667 9.60465C8.66667 10.5393 8.6656 11.1912 8.5979 11.6831C8.53213 12.1609 8.41183 12.4139 8.22733 12.5941C8.04281 12.7743 7.7838 12.8919 7.2946 12.9561C6.791 13.0222 6.1236 13.0233 5.16667 13.0233L4.5 13.0233C3.54307 13.0233 2.87567 13.0222 2.37207 12.9561C1.88287 12.8918 1.62387 12.7743 1.43933 12.5941C1.2548 12.4139 1.13453 12.1609 1.06873 11.6831C1.00107 11.1912 0.999999 10.5393 0.999999 9.60465L1 4.39535C1 3.46067 1.00107 2.80879 1.06873 2.3169C1.13453 1.83908 1.2548 1.5861 1.43933 1.40586C1.62387 1.22562 1.88287 1.10815 2.37207 1.04388C2.87567 0.977785 3.54307 0.976744 4.5 0.976744L5.16667 0.976744C6.1236 0.976744 6.791 0.977786 7.2946 1.04388C7.7838 1.10815 8.04281 1.22562 8.22733 1.40586C8.41183 1.5861 8.53213 1.83908 8.5979 2.3169C8.6656 2.80879 8.66667 3.46067 8.66667 4.39535C8.66667 4.66506 8.89052 4.88372 9.16667 4.88372C9.44281 4.88372 9.66667 4.66506 9.66667 4.39535L9.66667 4.3596Z"
            fill="#486497"
          />
        </svg>
        <span className="text-secondary text-sm font-normal">
          {t("sidebar.account.signout")}
        </span>
      </a>
    </div>
  );
};

export default MyAccount;
